module.exports = __webpack_public_path__ + "static/media/nexone-background-2.11509962.webp";